function useRangePicker({ onChange }) {
    const handleChangeRaw = (event) => {
        // Clear values when start date or end date was cleared via Backspace or Delete
        if (!event.target.value && event.target.value !== undefined) {
            onChange([null, null]);
        }
    };
    return {
        handleChangeRaw,
    };
}

export { useRangePicker };
//# sourceMappingURL=useRangePicker.js.map
